const folderPanelActionsTypes = {
    SET_LOADING: "SET_LOADING",
    CONTENT_LOADED: "CONTENT_LOADED",
    MORE_CONTENT_LOADED: "MORE_CONTENT_LOADED",
    LOAD_CONTENT_ERROR: "LOAD_CONTENT_ERROR",
    FILE_DOWNLOADED: "FILE_DOWNLOADED",
    FOLDER_DELETED: "FOLDER_DELETED",
    DELETE_FOLDER_ERROR: "DELETE_FOLDER_ERROR",
    CLOSE_TOP_PANELS: "CLOSE_TOP_PANELS",
    FILE_DELETED: "FILE_DELETED",
    DELETE_FILE_ERROR: "DELETE_FILE_ERROR",
    CHANGE_SEARCH: "CHANGE_SEARCH",
    FILES_SEARCHED: "FILES_SEARCHED",
    SEARCH_FILES_ERROR: "SEARCH_FILES_ERROR",
    URL_COPIED_TO_CLIPBOARD: "URL_COPIED_TO_CLIPBOARD",
    CHANGE_SORTING: "CHANGE_SORTING"
};

export default folderPanelActionsTypes;